import { get, isFunction } from 'lodash';

export const exportCsv = (data, name = 'license列表') => {
    // “\ufeff” BOM头
    var uri = 'data:text/csv;charset=utf-8,\ufeff' + encodeURIComponent(data)
    var downloadLink = document.createElement('a')
    downloadLink.href = uri
    downloadLink.download = name + '.csv' || 'temp.csv'
    document.body.appendChild(downloadLink)
    downloadLink.click()
    document.body.removeChild(downloadLink)
  }

export default exportCsv;